import injectSheet from 'react-jss';

import RightYAxis from './component';
import styles from './styles';

export default injectSheet(styles)(RightYAxis);
